import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-popup-message',
  templateUrl: './popup-message.component.html',
  styleUrls: ['./popup-message.component.css']
})
export class PopupMessageComponent implements OnInit {
  @Input() message: string;
  @Output() close = new EventEmitter<void>();
  
  constructor() { }

  ngOnInit(): void {
    
  }

  onClose(){
    this.close.emit();
  }
}
